import { Injectable } from '@angular/core';


@Injectable()
export class StorageService {

    getLocalStorage(key: string): any {
        return window.localStorage.getItem(key);
    }

    setLocalStorage(key: string, value: string) {
        window.localStorage.setItem(key, value);
    }

    removeLocalStorage(key: string) {
        window.localStorage.removeItem(key);
    }

    clearLocalStorage() {
        window.localStorage.clear();
    }

    getSessionStorage(key: string): any {
        return window.sessionStorage.getItem(key);
    }

    setSessionStorage(key: string, value: string) {
        window.sessionStorage.setItem(key, value);
    }

    removeSessionStorage(key: string) {
        window.sessionStorage.removeItem(key);
    }
    
    clearSessionStorage() {
        window.sessionStorage.clear();
    }

}
